import Service from '@root/common/base/Service';
import { ServiceInterface } from '@root/common/types/service';

import { GetIssues } from '../types/issue';
import getIssues from '@root/modules/issue/graphql/getIssues.graphql';

import { getPageOffset } from '@root/common/utils/getPageOffset';

type ServiceVariables = { domain?: string; page?: string };

export default class IssuesService extends Service implements ServiceInterface {
  private async fetchIssues(variables: ServiceVariables) {
    const apiProvider = this.createProvider('GraphQL');
    apiProvider
      .selectAPI('content-api-v3')
      .setLinkOptions({ useAutomaticPersistedQueries: true, useGETAutomaticPersistedQueries: true })
      .setCacheOptions({ key: `fetchIssues:${JSON.stringify(variables)}`, ttl: 30 })
      .enableCache(true);

    const options = Object.assign({ query: getIssues }, { variables });
    const response = await apiProvider.request<GetIssues['data']>(options);

    if (!response.issues.data || !(response.issues.data.length > 0)) {
      this.handleError();
    }

    return {
      issues: response.issues.data,
      pager: response.issues.pager,
    };
  }

  public handleError() {
    throw {
      message: 'issue.error.not_found',
      statusCode: 404,
    };
  }

  public async fetch({ domain, page }: ServiceVariables) {
    const isHealthy = this.getHealthCheckStatus('content-api-v3');
    const limit = 40;
    const offset = getPageOffset(limit, page);
    const variables: GetIssues['variables'] = { domain, offset, limit };

    if (!isHealthy) {
      this.handleError();
    }

    const response = await this.fetchIssues(variables);

    return response;
  }
}

export function fetchIssues(variables: ServiceVariables, { req }: { req: PortalRootIncomingMessage }) {
  const issuesService = new IssuesService({ req });
  return issuesService.fetch(variables);
}
